export class UserCardTypeTypeApiModel {
  number: number;

  name: string;

  description: string;
}
